<template>
    <v-dialog v-model="shows" width="100%" max-width="720" content-class="rounded-lg">
        
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <v-sheet class="full-height">

            <v-layout column fill-height>
                <bottom-sheet-header style="position: relative">
                    연령차별금지 주요내용
                    <v-btn small text fab tile absolute right color="white" @click="shows = false"> <v-icon>mdi-close</v-icon> </v-btn>
                </bottom-sheet-header>
            
                <v-sheet class="scroll-primary py-40 px-60" style="flex: 1 1 auto; overflow-y: auto">
                    <p class="page-text mb-12 mb-lg-20">채용공고에 합리적인 이유 없이 “00세 이하”, “1900년 이후 출생자”, “2000년 졸업자”, “대학졸업 후 2년 이내” 등 직·간접적인 연령제한을 할 수 없게 되었습니다. 모집·채용에서 불합리한 연령제한 시 고용상 연령차별 금지 및 고령자 고용촉진에 관한 법률 위반에 따른 500만원 이하의 벌금이 부과될 수 있습니다.</p>
                    <vertical-table v-bind="{ items }">
                        <template slot="차별로 보지 않는 사례">
                            <ul>
                                <li class="mb-4">· 직무성질상 특정 연령기준이 불가피한 경우(진정직업자격)<br />연극.영화에서 청년역할의 수행을 위한 연령제한 등</li>
                                <li class="mb-4">· 근속기간의 차이를 고려하여 임금이나 임금 외의 금품과 복리후생에서 합리적인 차등을 두는 경우</li>
                                <li class="mb-4">· 법률 등에 근거한 정년의 설정</li>
                                <li>· 이 법이나 다른 법률에 따라 특정 연령집단의 고용유지ㆍ촉진을 위한 지원조치를 하는 경우</li>
                            </ul>
                        </template>
                    </vertical-table>
                </v-sheet>
            </v-layout>
        </v-sheet>
    </v-dialog>
</template>

<script>
import VerticalTable from "@/components/dumb/vertical-table.vue";
import BottomSheetHeader from "@/components/dumb/bottom-sheet-header.vue";

const items = [
    {
        term: "관련법령",
        data: `고용상 연령차별금지 및 고령자 고용촉진에 관한 법률
제4조의4 제1항 제1호에 의거 근로자를 모집하거나 채용 시 합리적인 이유 없이 연령을 이유로 차별할 수 없음
<차별 시 500만원 이하 벌금>
<시정명령 불이행 시 3천만원 이하의 과태료 부과>`,
    },
    { term: "차별사례", data: "지원자의 나이를 제한하거나 특정 연령층을 선호하는 경우" },
    { term: "차별로 보지 않는 사례" },
];

export default {
    components: { VerticalTable, BottomSheetHeader, },
    data: () => ({
        shows: false,
        items,
    }),
};
</script>

<style lang="scss" scoped>
li{
    text-indent: -8px;
    padding-left: 8px;
}
</style>